function getChildNodeIndex(childNode) {
  const parentNode = childNode.parentNode;

  return Array.prototype.indexOf.call(parentNode.children, childNode);
}

export default getChildNodeIndex;
